import React from "react";

export const SessionContent = { session:false };

const SessionContentChambaticon = React.createContext(SessionContent);

export default SessionContentChambaticon;